import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck'
import Button from '@space-lib/components/button'
import Icon from '@space-lib/components/icon'
import { Actions, Entities } from '@space-lib/datahub'
import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { useTranslation } from 'react-i18next'

import { useReadAllMutation } from './useReadAllMutation'

const NotificationsHeader = () => {
  const { t } = useTranslation()
  const { sendDataHubEvent } = useDataHubEvents()

  const { mutate: readAll } = useReadAllMutation()

  const handleReadAll = () => {
    sendDataHubEvent({
      group: Entities.NOTIFICATIONS,
      name: Actions.CLICK_NOTIFICATIONS_READ_ALL
    })

    readAll()
  }

  return (
    <hot-dropdown-menu-header class='_p-0' data-test='dropdown-notifications-header'>
      <div className='_d-flex _justify-content-center _pb-3'>
        <Button variation='tertiary' className='_text-blue' onClick={handleReadAll}>
          <Icon icon={faCheck} className='_mr-2 _text-blue' />
          {t('notifications.mark_as_read')}
        </Button>
      </div>
    </hot-dropdown-menu-header>
  )
}

export default NotificationsHeader
